import React, { useState } from "react";
import { Link } from "react-router-dom";
import {AiOutlineLogout,AiFillProfile } from "react-icons/ai";
import logo from '../../assets/logo/full_logo.svg';
import treeLogo from '../../assets/logo/MMF_FinalLogo.ico';
import { useAppContext } from '../../AppContext';
import './Nav.css';

const Nav = () => {
  const { state } = useAppContext();
  const member_id = state.member_id;
  const [search, setSearch] = useState('');

  const userData = JSON.parse(localStorage.getItem('userData')) || {};
  const profilePicUrl = userData.member_details?.profile_pic || '';

  return (
    <nav>
      <div className="n-logo">
        <Link to={`/webtree/${member_id}`} className='logo' style={{ color: "black", textDecoration: "none" }}>
          <img src={logo} width="150" height="50" alt="logo" />
        </Link>
      </div>

      {/* <div className="n-form-button">
        <form className="n-form" onSubmit={(e) => e.preventDefault()}>
          <SearchIcon className="search-icon" />
          <input
            type="text"
            placeholder="Search post"
            id="n-search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </form>
      </div> */}

      <div className="social-icons">
        <Link to={`/webtree/${member_id}`} className='nav-link'>
        <img src={treeLogo} width="30" height="30" alt="logo" />
        </Link>

        <Link to={`/profile/${member_id}`} className='nav-link'>
          <AiFillProfile className="nav-icons" />
        </Link>

        {/* <Link to="/notification" className='nav-link'>
          <IoNotificationsOutline className="nav-icons" />
        </Link> */}
        {/* <AiOutlineAndroid className='nav-icons' />
        <AiOutlineApple className='nav-icons' /> */}
        
        <Link to="/logout" className='nav-link'>
      <AiOutlineLogout className='nav-icons' />
        </Link>
      </div>
      {/* <div className="n-profile">
        <Link to={`/profile/${member_id}`}>
          <img
            src={profilePicUrl || Profile}
            className="n-img"
            style={{ marginBottom: "-7px" }}
            alt="profile"
          />
        </Link>
      </div> */}
    </nav>
  );
};

export default Nav;
